<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">学生管理</Breadcrumb-item>
        <Breadcrumb-item>体验学生</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="120" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="6">
            <Form-item label="状态：">
              <Select v-model.number="queryParam.lessonStatus" placeholder="全部"
                      clearable @on-change="search">
                <Option v-for="item in userLessonStatusList"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="是否分配课程顾问：">
              <Select v-model.number="queryParam.isAdviser" placeholder="全部"
                      clearable @on-change="search">
                <Option v-for="item in isAdviserList"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="课程顾问昵称：">
              <Input placeholder="支持模糊搜索" name="studyAdviserName"
                     v-model="queryParam.adviserName"></Input>
            </Form-item>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col :span="6">
            <Form-item label="学生" :label-width="60">
              <Input placeholder="ID/手机号/姓名" name="searchKeyword"
                     v-model="queryParam.searchKeyword"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="渠道：">
              <channel-select v-model="queryParam.regType"></channel-select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="渠道来源：" prop="tchChannel">
              <Select v-model="queryParam.tchChannel" clearable>
                <Option v-for="item in $constant.tchChannel" :value="item.code" :key="item.code">
                  {{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="9">
            <Form-item label="创建时间">
              <Row>
                <Col :span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               @on-change="startTimeDateChange" v-model="startTime" style="width: 100%;"></Date-picker>
                </Col>
                <Col :span="1" style="text-align: center">-</Col>
                <Col :span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               @on-change="endTimeDateChange" v-model="endTime" style="width: 100%;"></Date-picker>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search">搜索
          </Button>
        </Row>
      </Form>
      <div class="btn-wrap">
        <Row type="flex" justify="space-between" :gutter="12">
          <Col>
            <!--              <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search"
                                @click="exportData">导出
                        </Button>-->
          </Col>
          <Col>
            <Button type="primary" icon="plus-round" @click="onInsertUser">添加学生</Button>
          </Col>
          <Col>
            <Button type="primary" @click="onAssignAdviser">分配课程顾问</Button>
          </Col>
        </Row>
      </div>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/user/experience/list"
      :params="queryParam" :onLoading="onLoading" @on-selection-change="selectionChange" ></List>

    <AssignAdviserModal :successCallback="search" :userList="selectionUser"
      v-model="showAssignAdviserModal" :restrictToSelf="true"></AssignAdviserModal>

    <UserTestNetworkModal :user="testNetworkParam" v-model="showTestNetworkModal" ></UserTestNetworkModal>

    <InsertUserModal :successCallback="search" v-model="showInsertUserModal" ></InsertUserModal>

    <UserTrialLessonModal :user="trialaLessonUser" v-model="showUserTrialLessonModal" ></UserTrialLessonModal>

    <UserInfoModal :value="editUser" @on-close="closeModal" :uid="uid" :successCallback="search"></UserInfoModal>
    <AiDrawer
      :visible.sync="aiVisible"
      :uid="aiUid"
      page-route="/user/userExperienceList"
      default-task-type="SALES_FOLLOWUP"
      @on-executed="search"
      @on-close="onAiClose"
    />
  </div>
</template>
<script>
import AssignAdviserModal from './AssignAdviserModal.vue'
import InsertUserModal from './modal/InsertUserModal.vue'
import UserTrialLessonModal from './UserTrialLessonModal.vue'
import UserTestNetworkModal from './modal/UserTestNetworkModal.vue'
import UserInfoModal from '../crm/UserInfoModal.vue'
import AiDrawer from '@/components/ai/AiDrawer'
import { bindAiAllowed } from '@/tools/aiAccess'
import Row from 'iview/src/components/grid/row';

export default {
  components: {AssignAdviserModal, InsertUserModal, UserTrialLessonModal, UserTestNetworkModal, UserInfoModal, AiDrawer},
  data () {
    let $constant = this.$constant
    let $moment = this.$moment

    return {
      exportLoading: false,
      searchLoading: false,
      reload: 0,
      aiVisible: false,
      aiUid: null,
      aiAllowed: false,
      queryParam: {
        searchKeyword: '',
        isAdviser: '',
        lessonStatus: '',
        adviserName: '',
        adviserMobile: '',
        regType: '',
        tchChannel: '',
        startTime: '',
        endTime: ''
      },
      startTime: '',
      endTime: '',
      isAdviserList: [{code: 1, text: '已分配'}, {code: 0, text: '未分配'}],
      editUser: false,
      // 添加学生
      showInsertUserModal: false,
      showUserTrialLessonModal: false,
      loadingInsertUser: false,
      ruleUser: {
        nickname: [
          {type: 'string', required: true, message: '昵称不能为空', trigger: 'blur'},
          {type: 'string', min: 1, max: 20, message: '昵称应为1-20个字', trigger: 'blur'}
        ],
        mobile: [
          {type: 'string', required: true, message: '登录账号不能为空', trigger: 'blur'}
        ],
        password: [
          {type: 'string', required: true, message: '密码不能为空', trigger: 'blur'}
        ]
      },
      uid: null,
      updateUser: {},
      trialaLessonUser: {},

      showAssignAdviserModal: false,
      selectionUser: [],

      // 约测网课
      showTestNetworkModal: false,
      testNetworkParam: {},
      testNetworkBookMaterialLevelList: [],

      bookMaterialLevelList: null,
      userListStatusList: $constant.userListStatus,
      userLessonStatusList: $constant.userLessonStatus,
      sexList: $constant.sex,
      title: [
        {
          type: 'selection',
          // width: 60,
          align: 'center'
        },
        {
          title: '学生ID、姓名',
          // width: 180,
          render: (h, params) => {
            let row = params.row
            return h('a', {on: {click: () => this.openInfoModal(row.id)}}, row.id + '-' + row.nickname)
          }
        },
        {
          title: '渠道',
          align: 'center',
          key: 'regType'
        },
        {
          title: '渠道来源',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let tchChannel = params.row.tchChannel
            let tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel)
            return h('div', tchChannelEnum && tchChannelEnum.text)
          }
        },
        {
          title: '手机号',
          align: 'center',
          // width: 150,
          key: 'mobile',
          render: (h, params) => {
            if (params.row.mobile.startsWith('n')) {
              return h('span', '')
            }
            return h('Poptip', {
              props: {
                trigger: 'hover'
              }
            }, [
              h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3)
                + "****" + params.row.mobile.substring(7) : params.row.mobile),
              // 当前行展示的数据
              h('div', {slot: 'content'}, params.row.mobile)
            ])
          }
        },
        {
          title: '注册时间',
          align: 'center',
          // width: 180,
          render: (h, params) => {
            let regTime = params.row.regTime
            if (regTime === 0) {
              return
            }
            return h('span', regTime && $moment(regTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
          }
        },
        {
          title: '课程顾问',
          key: 'adviserName',
          // width: 150,
          render: (h, params) => {
            return h('span', params.row.adviserName || '未分配')
          }
        },
        {
          title: '状态',
          align: 'center',
          // width: 140,
          render: (h, params) => {
            let statusEnum = $constant.getEnum($constant.userLessonStatus, params.row.lessonStatus)
            return h('span', statusEnum && statusEnum.text)
          }
        },
        {
          title: '操作',
          align: 'center',
          // width: 140,
          render: (h, params) => {
            let row = params.row
            let btn = []
            if (this.aiAllowed) {
              btn.push(h('Dropdown-item', {props: {name: 'ai'}}, 'AI'))
            }
            btn.push(h('Dropdown-item', {props: {name: 'testNetwork'}}, '约测网课'))
            if (row.lessonStatus !== 1 && row.lessonStatus !== 2) {
              btn.push(h('Dropdown-item', {props: {name: 'completeTestNetwork'}}, '已通过测网'))
            }
            btn.push(h('Dropdown-item', {props: {name: 'trialLesson'}}, '约试听课'))
            if (row.lessonStatus !== 2) {
              btn.push(h('Dropdown-item', {props: {name: 'completeTrialLesson'}}, '已试听'))
            }
            btn.push(h('Dropdown-item', {props: {name: 'paid'}}, '已付款'))

            return h('div', [
              h('span', {class: 'divider'}),
              h('Dropdown', {
                props: {
                  transfer: true,
                  trigger: 'click',
                },
                on: {
                  'on-click': (name) => {
                    let row = params.row
                    if (name === 'ai') {
                      this.aiUid = row.id
                      this.aiVisible = true
                    } else if (name === 'testNetwork') {
                      this.onTestNetwork(row)
                    } else if (name === 'completeTestNetwork') {
                      this.onCompleteTestNetwork(row)
                    } else if (name === 'trialLesson') {
                      this.onTrialLesson(row)
                    } else if (name === 'completeTrialLesson') {
                      this.onCompleteTrialLesson(row)
                    } else if (name === 'paid') {
                      this.onPaid(row)
                    }
                  }
                }
              }, [
                h('a', [
                  h('span', '更多 '),
                  h('Icon', {props: {type: 'ios-arrow-down'}})
                ]),
                h('Dropdown-menu', {slot: 'list'}, btn)
              ])
            ])
          }
        }
      ]
    }
  },
  mounted: function () {
    let query = this.$route.query
    if (query) {
      if (query.startTime) {
        this.startTime = parseInt(query.startTime) * 1000
      }
      if (query.endTime) {
        this.endTime = parseInt(query.endTime) * 1000
      }
      if (query.lessonStatus) {
        this.queryParam.lessonStatus = parseInt(query.lessonStatus)
      }
      if (query.isAdviser) {
        this.queryParam.isAdviser = parseInt(query.isAdviser)
      }
      if (query.searchKeyword) {
        this.queryParam.searchKeyword = query.searchKeyword
      }
      if (query.adviserName) {
        this.queryParam.adviserName = query.adviserName
      }
      if (query.adviserMobile) {
        this.queryParam.adviserMobile = query.adviserMobile
      }
      if (query.regType) {
        this.queryParam.regType = query.regType
      }
    }
  },
  created: function () {
    bindAiAllowed(this)
    let query = this.$route.query
    if (query) {
      if (query.startTime) {
        this.startTime = parseInt(query.startTime) * 1000
      }

      if (query.endTime) {
        this.endTime = parseInt(query.endTime) * 1000
      }
      if (query.lessonStatus) {
        this.queryParam.lessonStatus = parseInt(query.lessonStatus)
      }
      if (query.isAdviser) {
        this.queryParam.isAdviser = parseInt(query.isAdviser)
      }
      if (query.searchKeyword) {
        this.queryParam.searchKeyword = query.searchKeyword
      }
      if (query.adviserName) {
        this.queryParam.adviserName = query.adviserName
      }
      if (query.adviserMobile) {
        this.queryParam.adviserMobile = query.adviserMobile
      }
      if (query.regType) {
        this.queryParam.regType = query.regType
      }
    }
  },
  methods: {
    startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    openInfoModal(val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserExperienceList'}
      })
      window.open(href, '_blank')
    },
    closeModal(val) {
      this.uid = null
      this.editUser = false
    },
    search(val) {
      this.selectionUser = []
      this.reload = new Date().getTime()
    },
    onLoading(loading) {
      this.searchLoading = loading
    },

    // 添加学生
    onInsertUser() {
      this.showInsertUserModal = true
    },
    // 分配课程顾问
    onAssignAdviser() {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配课程顾问的学生！')
        return
      }
      this.showAssignAdviserModal = true
    },
    exportData(type) {
      this.exportLoading = true
      this.$http.get('/user/experience/export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '体验学生.csv'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    },
    // 约测网课
    onTestNetwork(row) {
      this.testNetworkParam = row
      this.showTestNetworkModal = true
    },

    // 约试听
    onTrialLesson(row) {
      this.showUserTrialLessonModal = true
      this.trialaLessonUser = row
    },

    // 完成测网课
    onCompleteTestNetwork(row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '确定 <b>' + row.nickname + '</b> 已通过测网？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/user/updateLessonStatus', {id: row.id, lessonStatus: 1}).then(function (res) {
            self.search()
            self.$Message.success('提交成功!')
            self.$Modal.remove()
          })
        }
      })
    },
    // 已试听
    onCompleteTrialLesson(row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '确定 <b>' + row.nickname + '</b> 已试听？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/user/updateLessonStatus', {id: row.id, lessonStatus: 2}).then(function (res) {
            self.search()
            self.$Message.success('提交成功!')
            self.$Modal.remove()
          })
        }
      })
    },
    // 已付款
    onPaid(row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '确定 <b>' + row.nickname + '</b> 已付款？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/user/updateIsPay', {id: row.id, isPay: 1}).then(function (res) {
            if (res.data) {
              self.search()
              self.$Message.success('提交成功!')
              self.$Modal.remove()
            }
          })
        }
      })
    },
    selectionChange(selection) {
      this.selectionUser = selection
    },
    onAiClose() {
      this.aiVisible = false
      this.aiUid = null
    },
    loadBookMaterialLevel() {
      let self = this
      if (self.bookMaterialLevelList) {
        return
      }
      self.$http.get('/bookMaterialLevel/listByCondition?status=1').then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.bookMaterialLevelList = res.data
      })
    }
  }
}

</script>

<style scoped>
.btn-wrap {
  display: flex;
  justify-content: end;
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// UserExperienceList.vue?1679895e